<style>
th.td-check .con-vs-checkbox {
  margin-right: 0 !important;
  display: none !important;
  margin-left: 0 !important;
}
.signature_pad {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
</style>

<template>
  <vx-card>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <h4>Gestión de correos</h4>
          </div>
        </div>
        <hr />
        <div class="vx-row mt-2">
          <div class="vx-col md:w-2/5 sm:w-full w-full">
            <label for>Persona</label>
            <vs-input
                v-model="vBusqueda"
                class="w-full"
                maxlength="250"
                placeholder=""
              />
            <!-- <v-date-picker v-model="fcalendarEdit" @input="mfechaEdit = false" color="grey darken-4" locale="es"></v-date-picker> -->
          </div>         
          <div class="vx-col md:w-1/4 sm:w-full w-full pt-5">
            <vs-button
              color="primary"
              class="w-full"
              type="border"
              icon-pack="feather"
              icon="icon-search"
              v-on:click="searchMailing()"
            >Buscar</vs-button>
          </div>
          <div class="vx-col md:w-1/4 sm:w-full w-full pt-5">
            <vs-button
              color="dark"
              class="w-full"
              type="border"
              icon-pack="feather"
              icon="icon-plus"
              @click="ActivePopup()"
            >Agregar</vs-button>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="vx-row mt-2">
      <div class="vx-col w-full">
        <ag-grid-vue
          ref="agGridTable"
          v-if="renderComponents"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="datos.columnDefs"
          :defaultColDef="datos.defaultColDef"
          :rowData="datos.json"
          autoSizeColumns="true"
          :animateRows="false"
          :floatingFilter="false"
          :pagination="true"
          :paginationPageSize="15"
          :suppressDragLeaveHidesColumns="false"
          :suppressMovable="false"
          :suppressPaginationPanel="false"
          overlayNoRowsTemplate="No se encontraron resultados."
          :enableRtl="$vs.rtl"
          style="max-height: 400px;width:100%"
          id
        ></ag-grid-vue>
      </div>
    </div>
     <vs-popup :title="titlePopup" :active.sync="popupActive">
      <form-wizard
        ref="wizard"
        color="rgba(var(--vs-primary), 1)"
        errorColor="rgba(var(--vs-danger), 1)"
        :title="null"
        :subtitle="null"
        :finishButtonText="'Guardar'"
        nextButtonText="Siguiente"
        backButtonText="Regresar"
        @on-complete="formSubmitted"
      >
        <tab-content title="Datos generales" class="mb-5" :before-change="validateStep1">
          <!-- tab 1 content -->
          <form data-vv-scope="step-1">
            <div class="vx-row">
              <div class="vx-col md:w-1/4 lg:w-1/4 w-full mt-5">
                <label for>Persona</label>               
                <br />
              </div>
              <div class="vx-col md:w-3/4 lg:w-3/4 w-full mt-5">
                 <vs-input
                  v-model="NombrePersona"
                  class="w-full"
                  name="v_NombrePersona"
                  v-validate="'required'"
                  maxlength="250"
                  :disabled="fgEditar ? true : false"
                />
                <span class="text-danger">{{ errors.first('step-1.v_NombrePersona') }}</span>               
              </div>        
            </div>  
            <div class="vx-row">
              <div class="vx-col md:w-1/4 lg:w-1/4 w-full mt-5">
                <label for>Cargo/Puesto</label>               
                <br />
              </div>
              <div class="vx-col md:w-3/4 lg:w-3/4 w-full mt-5">
                 <vs-input
                  v-model="CargoPersona"
                  class="w-full"
                  name="v_CargoPersona"
                  v-validate="'required'"
                  maxlength="250"
                  :disabled="fgEditar ? true : false"
                />
                <span class="text-danger">{{ errors.first('step-1.v_CargoPersona') }}</span>               
              </div>        
            </div>         
            <div class="vx-row">
                <div class="vx-col md:w-1/4 lg:w-1/4 w-full mt-5">
                    <label for>Correo</label>               
                    <br />
                </div>
                <div class="vx-col md:w-3/4 lg:w-3/4 w-full mt-5">
                    <vs-input
                    v-model="CorreoElectronico"
                    class="w-full"
                    type="email"
                    name="v_CorreoElectronico"
                    v-validate="'required|email'"
                    maxlength="250"
                    :disabled="fgEditar ? true : false"
                    />
                    <span class="text-danger">{{ errors.first('step-1.v_CorreoElectronico') }}</span>               
                </div>    
            </div>     
            <!-- <div class="vx-row">
                <div class="vx-col w-full mt-5">
                    <vs-button
                    color="dark"
                    class="w-full"
                    type="border"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="ActivePopup()"
                    >Agregar</vs-button>
                </div>
            </div>         -->
          </form>
        </tab-content>
        <template slot="custom-buttons-right">
          <wizard-button class="green-btn">
              <button
              class="wizard-btn"
              v-on:click="cancelForm()"
              style="background-color: rgba(var(--vs-danger), 1); border-color: rgba(var(--vs-danger), 1); color: white;"
            >Cancelar</button>              
          </wizard-button>
      </template>
      </form-wizard>
    </vs-popup>
    <vs-popup width="550px" title="Eliminar correo no deseado" :active.sync="active2">
        <div class="con-content">
          <p>
            ¿Está seguro que desea eliminar el correo seleccionado?
          </p>
        </div>

        <div class="con-footer float-right mt-5">
            <vs-button @click="acceptDelete" transparent color="danger" type="filled">
              Aceptar
            </vs-button>
            <vs-button @click="active2=false" dark transparent color="danger" type="border">
              Cancelar
            </vs-button>
          </div>
      </vs-popup>
  </vx-card>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
// import AgGridTable from "@/components/ag-grid-table/AgGridTable.vue";
import $ from "jquery";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import authConfig from "@/../auth_config.json";
//const dict = FieldsValidate;

// register custom messages
//Validator.localize("en", dict);

export default {
  data() {
    return {
      //CAMPOS ACTIVADOS
      //STEP 1 CAMPOS HOJA INSPECCION
      
      //Datos generales
     
      titlePopup: "",
      renderForm: true,
      fgReportes: true,
      popupActive: false,
      fgEditar: false,
      active2: false,
      //languages: lang,
      title: "Número de viajes marcado como tienda al mes",
      datos: {
        columnDefs: [],
      },
      renderComponents: true,
      fgVisibleLlanta: false,
      vBusqueda: "",
      NombrePersona: "",
      CorreoElectronico: "",
      CorreoPermitidoID: null,
      CargoPersona: null,
      idDelete: null
      
    };
  },
  components: {
    AgGridVue,
    FormWizard,
    "v-select": vSelect,
    TabContent,
  },
  computed: {},
  watch: {    
    popupActive(fg) {
      if (fg == false) {
        this.clearForm();
        setTimeout(() => {
          this.$vs.loading.close();
        }, 500);
      }
      this.errors.clear();
    }
  },
  created() {
    if (authConfig.EmpresaId > 0) {
        this.ValidateRules();
    } else {
        this.$router.push({ path: "/" });
    }
  },
  mounted() {
       
  },
  beforeMount() {
    setTimeout(() => {
      this.searchMailing();
    }, 500);
    this.forceRerender();
    //this.loadSignatures();
  },
  methods: {

    //==============
    forceRerender() {
      this.renderComponents = false;

      this.$nextTick(() => {
        this.renderComponents = true;
      });
    },
    clearForm() {
      //this.$refs.wizard.navigateToTab(0);
      //this.$refs.wizard.Reset();

        this.CorreoPermitidoID = null;
        this.errors.clear();
        this.NombrePersona = "";
        this.CorreoElectronico = "";       
        this.CargoPersona = "";
        this.$refs.wizard.navigateToTab(0);
      
    },
    ActivePopup() {
      this.titlePopup =
        this.CorreoPermitidoID > 0
          ? "Editar correo permitido"
          : "Agregar correo permitido";
      this.popupActive = true;
      //this.forceRerenderForm();
    },    
    searchMailing() {
      const vm = this;
      const parametros = {};

      //vm.Detalle_Tabla = []
      /* if (vm.noInspeccion === null || vm.noInspeccion === '' || vm.noInspeccion === 0 || isNaN(vm.noInspeccion) === true) {
        vm.msjException = true
        vm.msjAlerta = 'Ingrese un número de inspección válido'
        return false
      } */      

      parametros.EmpresaID = authConfig.EmpresaId;
      parametros.ID = 2; //this.$route.query.Id;
      parametros.desDetalle = this.vBusqueda;
      //      vm.overlay = true
      //vm.Api + "/api/HojaInspeccion/GetByRango"
      //
      $.ajax({
        url: vm.WS + "/Mailing/GetCorreosPermitidos",
        type: "POST",
        dataType: "Json",
        async: false,
        data: parametros,
        success: res => {
          // this.datos.gridOptions = {};
          // this.datos.columnDefs = [];
          // this.datos.defaultColDef = {
          //   editable: false
          // };
          // this.datos.gridApi = null;
          this.datos = res.Data;
          //     //this.forceRerender();
          // }
        }
      });

      this.forceRerender();
      this.validateColumns();
    },
    validateColumns() {
      this.datos.columnDefs = [];
      if (this.datos.json.length > 0) {
        this.datos.columnDefs = [{ headerName: "PERSONA", field: "NombrePersona", width: 500 }];
        this.datos.columnDefs.push({
          headerName: "CORREO",
          field: "CorreoElectronico",
          width: 500
        });        
        this.datos.columnDefs.push({
          headerName: "CARGO/PUESTO",
          field: "CargoPersona",
          width: 500
        });       
        this.datos.columnDefs.push({
          headerName: "",
          filter: false,
          width: 100,
          pinned: "right",
          cellRenderer: function boton() {
              
            return (
              `<i class="feather icon-edit-2 editar" style="font-size: 24px;cursor: pointer" title="Editar"></i>`
            );
          },
          onCellClicked: params => {
            this.editCorreo(params.data.CorreoPermitidoID);
            //console.log(params);
          }
        });
        this.datos.columnDefs.push({
          headerName: "",
          filter: false,
          width: 100,
          pinned: "right",
          cellRenderer: function boton() {
            return `<i class="feather icon-delete imprimir" style="font-size: 24px;cursor: pointer" title="Eliminar"></i>`;
          },
          onCellClicked: params => {
            //console.log(params);
            this.EliminarCorreo(params.data.CorreoPermitidoID);
          }
        });
        
        this.datos.gridOptions.api.sizeColumnsToFit();
        // {
        //   headerName: "",
        //   filter: false,
        //   width: 100,
        //   pinned: "right",
        //   cellRenderer: function boton(params) {
        //     return `<i class="feather icon-printer imprimir" style="font-size: 24px;cursor: pointer" title="Imprimir"></i>`;
        //   },
        //   onCellClicked: function(params) {
        //     console.log(params.data);
        //   }
        // }
      }
    },
    ValidateRules(){
        let dict = {
            custom: {},
        };
        
        dict.custom["v_NombrePersona"] = {
            required: "El campo nombre es requerido.",
        };      
        
         dict.custom["v_CargoPersona"] = {
            required: "El campo cargo/puesto es requerido.",
        };  
    
        dict.custom["v_CorreoElectronico"] = {
            required: "El campo correo electrónico es requerido.",
            email: "Ingrese un correo electrónico válido.",
        };        

        Validator.localize("en", dict);
    },
    EliminarCorreo(x){      
        this.idDelete = x;
        this.active2 = true;
    },

    acceptDelete() {
        this.active2 = false;
      const vm = this;
      vm.selected = [];
      vm.pointsMarker = [];
      vm.banderaEdit = 1;
      vm.overlay = true;
      let id = this.idDelete;
      $.ajax({
        url: this.WS + "/Mailing/DeleteCorreoById",
        type: "POST",
        dataType: "Json",
        data: { ID: id },
        async: false,
        success: res => {
          if (res.Estatus == -1) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: "Ocurrió un error inesperado, favor de intentarlo de nuevo."
            });

            return;
          } else if (res.Estatus == 0) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: res.Mensaje
            });

            return;
          }      
          
          this.$vs.notify({
              time: 5000,
              color: "success",
              fixed: true,
              title: "Operación exitosa",
              text:
                "El correo se ha eliminado correctamente"
            });

            this.active2 = false;
            vm.searchMailing();                  
        }
      });
    },
   

    cancelForm(){
        this.popupActive = false;
        this.clearForm();
    },
    
  editCorreo(x) {
      const vm = this;
      vm.selected = [];
      vm.pointsMarker = [];
      vm.banderaEdit = 1;
      vm.overlay = true;
      $.ajax({
        url: this.WS + "/Mailing/getCorreoById",
        type: "POST",
        dataType: "Json",
        data: { ID: x },
        async: false,
        success: res => {
          if (res.Estatus == -1) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: "Ocurrió un error inesperado, favor de intentarlo de nuevo."
            });

            return;
          } else if (res.Estatus == 0) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: res.Mensaje
            });

            return;
          }

          
          vm.CorreoPermitidoID = x;
          vm.CorreoElectronico = res.Data.CorreoElectronico;
          vm.NombrePersona = res.Data.NombrePersona;          
          vm.CargoPersona = res.Data.CargoPersona;
          vm.ActivePopup();          
        }
      });
    },
    // // imprimirRecepcion(x) {
    // //   var parameters = { idHoja: x };
    // //   window.location.href =
    // //     this.WS +
    // //     "/Checklist/ImprimirRecepcion?json=" +
    // //     JSON.stringify(parameters);
    // // },

    formSubmitted() {
      this.saveInformacion();      
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1").then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },   
    // //SAVE

    saveInformacion() {
      this.$vs.loading();

      const vm = this;
      const datosSend = {};

      datosSend.CorreoPermitidoID = vm.CorreoPermitidoID;
      datosSend.EmpresaID = authConfig.EmpresaId;
      datosSend.NombrePersona = vm.NombrePersona;
      datosSend.CargoPersona = vm.CargoPersona;
      datosSend.CorreoElectronico = vm.CorreoElectronico;
     
      $.ajax({
        url: this.WS + "/Mailing/save",
        type: "POST",
        dataType: "Json",
        async: false,
        data: datosSend,
        success: res => {
          if (res.Estatus == -1) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: "Ocurrió un error inesperado, favor de intentarlo de nuevo."
            });

            setTimeout(() => {
              this.$vs.loading.close();
            }, 500);
            return;
          } else if (res.Estatus == 0) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: res.Mensaje
            });
             setTimeout(() => {
              this.$vs.loading.close();
            }, 500);
            return;
          }

          //vm.saveCuestionario(res.body.hojasInspeccion[0].HojaInspeccionID);
          //vm.getInfoInspeccionxID(res.Data);
          if (vm.CorreoPermitidoID > 0) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              fixed: true,
              title: "Operación exitosa",
              text:
                "El correo se ha actualizado correctamente"
            });
          } else {
            this.$vs.notify({
              time: 5000,
              fixed: true,
              color: "success",
              title: "Operación exitosa",
              text: "El correo permitido se ha creado con éxito"
            });
          }

          setTimeout(() => {
            this.$vs.loading.close();
            this.popupActive = false;
            //this.forceRerenderForm();
            vm.searchMailing();
          }, 500);
        },
        error: function() {
          //console.log(errorThrown)
          this.$vs.notify({
            time: 5000,
            color: "warning",
            title: "Ocurrió un error inesperado",
            text: "No se ha podido conectar al servidor. Intente más tarde"
          });

          setTimeout(() => {
            this.$vs.loading.close();
          }, 500);
        }
      });
    },
  }
};
</script>